import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const OpeningAnimation = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    // プレビュー環境では即座にアニメーションをスキップ
    if (__IS_PREVIEW__) {
      setShow(false);
      return;
    }

    const hasSeenAnimation = sessionStorage.getItem('hasSeenAnimation');
    
    if (hasSeenAnimation) {
      setShow(false);
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    const timer = setTimeout(() => {
      setShow(false);
      sessionStorage.setItem('hasSeenAnimation', 'true');
    }, prefersReducedMotion ? 800 : 3000);

    return () => clearTimeout(timer);
  }, []);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: prefersReducedMotion ? 0.3 : 1, ease: 'easeInOut' }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-gradient-to-br from-lightgray to-cream"
        >
          <div className="flex flex-col items-center justify-center gap-6">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: prefersReducedMotion ? 0.3 : 1.2, ease: 'easeOut' }}
              className="flex items-center justify-center"
            >
              <img 
                src="https://static.readdy.ai/image/4df5c7deddaddbbeeb26e7a7cacf2afd/04612241165ac6755bde3331d7ab7803.png" 
                alt="SINAX Logo" 
                className="w-72 h-72 object-contain"
              />
            </motion.div>

            <motion.h1
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ 
                duration: prefersReducedMotion ? 0.3 : 0.8, 
                delay: prefersReducedMotion ? 0 : 0.4,
                ease: 'easeOut' 
              }}
              className="font-serif text-5xl tracking-[0.3em] text-darkgray text-center"
            >
              SINAX
            </motion.h1>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OpeningAnimation;
